import { useEffect, useState } from "react";
import axios from "axios";
import { LogIn, ShieldX, UserPlus, FileSignature, Activity } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const sumActions = (byAction, period, keys) =>
  keys.reduce((acc, k) => acc + ((byAction?.[k] || {})[period] || 0), 0);

export default function AuditStatsCards() {
  const [stats, setStats] = useState(null);

  useEffect(() => {
    axios.get(`${API}/audit/stats`, { withCredentials: true })
      .then(({ data }) => setStats(data))
      .catch(() => setStats(null));
  }, []);

  if (!stats) return null;

  const { by_action, totals } = stats;
  const tiles = [
    {
      key: "logins",
      label: "Logins heute",
      value: sumActions(by_action, "today", ["auth.login.success", "auth.login.success.recovery"]),
      sub: `${sumActions(by_action, "week", ["auth.login.success", "auth.login.success.recovery"])} diese Woche`,
      Icon: LogIn,
      color: "text-green-400",
    },
    {
      key: "failed",
      label: "Fehl-Logins heute",
      value: sumActions(by_action, "today", ["auth.login.failed", "auth.2fa.failed"]),
      sub: `${sumActions(by_action, "week", ["auth.login.failed", "auth.2fa.failed"])} diese Woche`,
      Icon: ShieldX,
      color: "text-red-400",
    },
    {
      key: "signups",
      label: "Newsletter-Anmeldungen",
      value: sumActions(by_action, "today", ["newsletter.subscribe", "newsletter.confirmed"]),
      sub: `${sumActions(by_action, "week", ["newsletter.subscribe", "newsletter.confirmed"])} diese Woche`,
      Icon: UserPlus,
      color: "text-[#C5993A]",
    },
    {
      key: "content",
      label: "Inhalts-Änderungen heute",
      value: sumActions(by_action, "today", [
        "event.created", "event.updated", "event.deleted",
        "job.created", "job.updated", "job.deleted",
        "charts.config.updated",
        "settings.notify_email.updated",
      ]),
      sub: `${totals.today} Aktionen insgesamt`,
      Icon: FileSignature,
      color: "text-blue-400",
    },
    {
      key: "total",
      label: "Aktionen gesamt",
      value: totals.all_time,
      sub: `${totals.today} heute · ${totals.yesterday} gestern`,
      Icon: Activity,
      color: "text-[#8899AA]",
    },
  ];

  return (
    <div
      data-testid="audit-stats-cards"
      className="grid grid-cols-2 lg:grid-cols-5 gap-3 mb-6"
    >
      {tiles.map((t) => {
        const Icon = t.Icon;
        return (
          <div
            key={t.key}
            data-testid={`audit-stat-${t.key}`}
            className="bg-[#12202f] border border-[#3A4F60]/30 rounded-lg p-4"
          >
            <div className="flex items-center justify-between mb-2">
              <div className="text-[10px] uppercase tracking-wider text-[#3A4F60]">{t.label}</div>
              <Icon className={`w-4 h-4 ${t.color}`} />
            </div>
            <div
              className="text-2xl font-heading text-white tabular-nums"
              data-testid={`audit-stat-${t.key}-value`}
            >
              {t.value.toLocaleString("de-DE")}
            </div>
            <div className="text-[11px] text-[#8899AA] mt-1 truncate">{t.sub}</div>
          </div>
        );
      })}
    </div>
  );
}
